import { render, staticRenderFns } from "./SilageTable.vue?vue&type=template&id=7504c316&scoped=true&lang=pug"
import script from "./SilageTable.vue?vue&type=script&lang=js"
export * from "./SilageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504c316",
  null
  
)

export default component.exports